import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { EvaluationAthleteProvider } from '../../providers/evaluation-athlete-provider.services';
import { CurrentUser } from "../../../common/providers/current-user";
import { CoachesProvider } from '../../../coaches/providers/coaches-provider';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  MAT_DIALOG_DATA, MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AnnualPlan } from "../../../common/models/annual-plan";
import { Athlete } from "../../../common/models/athlete";
import { Evaluation } from "../../../common/models/evaluation";
import { Organization } from "../../../common/models/organization";
import { NgForOf, NgIf } from "@angular/common";
import { MatButton } from "@angular/material/button";
import { MatOption } from "@angular/material/autocomplete";
import { MatFormField, MatInput, MatSuffix } from "@angular/material/input";
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from "@angular/material/datepicker";
import { MatSelect } from "@angular/material/select";
import { MatError, MatLabel } from "@angular/material/form-field";
import { EvaluationProvider } from "../../providers/evaluation-provider.services";
import { map, of, switchMap } from "rxjs";
import { User } from "../../../common/models/user";

@Component({
  selector: 'evaluation-athlete-dialog-evaluation-new',
  templateUrl: './evaluation-athlete-dialog-evaluation-new.component.html',
  styleUrls: ['./evaluation-athlete-dialog-evaluation-new.scss'],
  imports: [
    ReactiveFormsModule,
    MatDialogClose,
    MatError,
    MatDialogTitle,
    NgIf,
    NgForOf,
    MatButton,
    MatOption,
    MatLabel,
    MatInput,
    MatFormField,
    MatDialogContent,
    MatDatepickerInput,
    MatDatepicker,
    MatSuffix,
    MatSelect,
    TranslateModule,
    MatDatepickerToggle,
    MatDialogActions
  ],
  standalone: true
})
export class EvaluationAthleteDialogEvaluationNewComponent implements OnInit {

    public isLoading = true;
    public evaluationNewForm: FormGroup = {} as FormGroup;
    public isSubmitting = false;
    public annualPlans: AnnualPlan[] = [];
    public annualPlan: AnnualPlan = {} as AnnualPlan;
    public startDate: Date = new Date();
    public athletes: Athlete[] = [];
    public rows: any;
    public types: string[] = [];
    public evaluations: Evaluation[] = [];
    public organization: Organization;
    public athleteUser: User = {} as User;
    public coachUser: User = {} as User;

    constructor(
      public dialog: MatDialogRef<EvaluationAthleteDialogEvaluationNewComponent>,
      private utils: UtilsProvider,
      private fb: FormBuilder,
      private utilsProvider: UtilsProvider,
      private evaluationProvider: EvaluationProvider,
      private evaluationAthleteProvider: EvaluationAthleteProvider,
      private currentUser: CurrentUser,
      private coachProvider: CoachesProvider,
      private toaster: MatSnackBar,
      private translator: TranslateService,
      @Inject(MAT_DIALOG_DATA) public data:any) {
        this.organization = data.organization;
        this.athleteUser = data.athleteUser;

        this.loadData();
    }

    public ngOnInit() {
        // this.authorizationChecker.setOrganization(this.organization);
    }

    public submitForm() {
        // this.authorizationChecker.denyAccessUnlessGranted(OrganizationRole.ID_COACH);
        this.isSubmitting = true;
        if (this.evaluationNewForm.valid) {
            // convert date manually to remove TZ
            this.evaluationNewForm.value.date = this.utilsProvider.DateToYmdHis(new Date(this.evaluationNewForm.value.date), false);
            // copy library annual plan as an athlete annual plan
            this.evaluationAthleteProvider.save(this.organization, this.evaluationNewForm.value).subscribe({
                next: (evaluation) => {
                    this.toaster.open(this.translator.instant('Evaluation_created'), '', { duration: 5000 });
                    this.dialog.close(evaluation);
                },
                error: (error) => {
                    this.toaster.open(this.translator.instant('Evaluation_not_created'), '', { duration: 5000 });
                    this.isSubmitting = false;
                }
            });
        } else {
            this.utils.validateAllFormFields(this.evaluationNewForm);
            this.isSubmitting = false;
        }
    }

    get f() {
        return this.evaluationNewForm.controls;
    }

    public loadData() {
      return this.coachProvider.get(this.organization.id!, this.currentUser.user?.id!).pipe(
        switchMap((coach) => {
          this.coachUser = coach;

          return this.evaluationProvider.findAll()
            .pipe(
              map((evaluations) => {
                this.evaluations = evaluations;
                let evaluation;
                if (this.data.evaluationType) {
                  evaluation = this.evaluations.find(evaluation => evaluation.type === this.data.evaluationType)
                }
                this.evaluationNewForm = this.fb.group({
                  organization: new FormControl(this.organization, [Validators.required]),
                  evaluation: new FormControl(evaluation, [Validators.required]),
                  date: new FormControl(new Date(), [Validators.required]),
                  athleteUserId: new FormControl(this.athleteUser.id, [Validators.required]),
                  coachUserId: new FormControl(this.coachUser.id, [Validators.required]),
                });
                this.isLoading = false;
              })
            );
        })
      ).subscribe({
        error: (error) => {
          this.toaster.open(this.translator.instant('Error_loading_data'), '', { duration: 5000 });
          this.isLoading = false;
        }
      })
    }
}
